import * as styles from "./PagesLayout.module.less"
import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Container as MuiContainer } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import theme from "../gatsby-theme-material-ui-top-layout/theme"

const Container = ({ children }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrlPlain
          }
        }
      }
    `
  )

  const siteUrlPlain = site.siteMetadata.siteUrlPlain

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <MuiContainer className={styles.mainLayout}>
        <MuiContainer className={styles.homeCardLayout}>
          <div style={{ margin: "0 auto" }}>{children}</div>
        </MuiContainer>
        <Box style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignContent: "center",
          textAlign: "center",
          height: "80px",
          borderTop: "1px solid #b7b7b7"
        }}>
          © {new Date().getFullYear()} made by {siteUrlPlain}
        </Box>
      </MuiContainer>
    </ThemeProvider>
  )
}
Container.propTypes = {
  children: PropTypes.node.isRequired
}

export default Container
